import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap'
import { glossaryDropDownAction, htmlFileTranslateAction, translateBatchDocAction, translateBatchDocMoreThan20Action, translateDocAction, viewTranslateBatchDocAction } from '../../redux/actions/translateAction';
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import "./translations.css"
import Loading from '../../components/ui/loader/loader';
import errorToast from '../../components/toast/errorToast';
import DocFileViewer from '../../components/ui/viewer/docViewer';
import TOSModal from '../../components/ui/Modal/tosModal';
import TranslatedDocFileViewer from '../../components/ui/viewer/translatedViewer';
import TranslationLayout from '../../components/ui/layouts/translate-layout';
import { useNavigate } from 'react-router-dom';
import { availableLanguages } from '../../components/data/language';
import downloadIcon from "../../assets/icons/downloads.png";
import { ImGoogleDrive } from "react-icons/im";
import successToast from '../../components/toast/successToast';
import GoogleDrivePicker from '../../components/buttons/googleDrive';
import LoaderModal from '../../components/ui/Modal/loaderModal';
import { saveAs } from 'file-saver';
import Popup from '../../components/ui/Modal/popUp';
import { useAuth } from '../../context/AuthContext';

/** TranslationPage -> previewing selected file , translating document with glosorry functionality  */
export default function TranslationPage({ file, fileType, fileUploadedData, numPages, onHide }) {
  const dispatch = useDispatch();
  const [targetLanguage, setTargetLanguage] = useState('');
  const [sourceLanguage, setSourceLanguage] = useState('en');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [filter, setFilter] = useState('');
  const [dataUrl, setDataUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [fileTranslated, setFileTranslated] = useState(false);
  const [isBatchTranslate, setIsBatchTranslate] = useState(false);
  const [batchTranslatedData, setBatchTranslatedData] = useState([])
  const [startIndex, setStartIndex] = useState(0);
  const [glossariesDropdown, setGlossariesDropdown] = useState(false);
  const [glossaryList, setGlossaryList] = useState([]);
  const [selectedGlossary, setSelectedGlossary] = useState('');
  const [selectedButton, setSelectedButton] = useState('');
  const [languageSets, setLanguageSets] = useState([sourceLanguage]);
  const [showPrompt, setShowPrompt] = useState(numPages > 20 ? true : false);
  const { isDemo, portalId } = useAuth();
  const [token, setAccessToken] = useState(null)
  const accessToken = localStorage.getItem('driveAccessToken') || null;
  const [showLoader, setShowLoader] = useState(false);
  const [translateText, setTranslateText] = useState(null);
  const [showPopup, setShowPopup] = useState(false)

  const visibleButtons = 4;
  const totalButtons = batchTranslatedData.length;


  const GlossariesDropdown = () => {
    setGlossariesDropdown(!glossariesDropdown);
    setShowDropdown(false);
  };

  const handleGlossaryLabelClick = (name) => {
    setSelectedGlossary(name);
    setGlossariesDropdown(false);
  };

  useEffect(() => {
    setLanguageSets([sourceLanguage, ...selectedLanguages, targetLanguage])
  }, [sourceLanguage, selectedLanguages, targetLanguage])

  useEffect(() => {
    const uniqueLanguageSets = [...new Set(languageSets)];
    const filteredArray = uniqueLanguageSets.filter(element => element);
    dispatch(glossaryDropDownAction({ targetLanguages: filteredArray }, onSuccess, onError));
  }, [languageSets]);

  useEffect(() => {
    if (glossaryList.length < 1) {
      setSelectedGlossary('')
    }
  }, [glossaryList]);

  const navigate = useNavigate()
  useEffect(() => {
    if (localStorage.getItem('logout') === 'true') {
      navigate(`/login/${portalId}`)
    }
  }, [])


  const onSuccess = (data) => {
    setGlossaryList(data.data.data);
  };

  const onError = (data) => {
    errorToast(data.data.message);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
    setGlossariesDropdown(false);
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (isDemo && checked && selectedLanguages.length > 14) {
      errorToast("You can't select more than 15 target languages")
    } else {
      if (checked) {
        setSelectedLanguages((prevSelectedLanguages) => [...prevSelectedLanguages, value]);
        setTargetLanguage(value);
      } else {
        setSelectedLanguages((prevSelectedLanguages) => prevSelectedLanguages.filter((lang) => lang !== value));
        if (targetLanguage === value) {
          setTargetLanguage('');
        }
      }
    }
  };

  useEffect(() => {
    if (selectedLanguages.length > 1) {
      setIsBatchTranslate(true);
      setTargetLanguage('')
    } else {
      setIsBatchTranslate(false)
      if (selectedLanguages.length === 1) {
        setTargetLanguage(selectedLanguages[0])
      }
    }
  }, [selectedLanguages])


  const handleFilterChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    setFilter(inputValue);
  };

  const filteredLanguages = availableLanguages.filter(
    (lang) =>
      lang.label.toUpperCase().includes(filter.toUpperCase()) && // Ensure case-insensitive filtering
      lang.value !== sourceLanguage // Exclude the source language
  );


  const handleTranslateButton = () => {
    if (fileType === "html") {
      const data = {
        sourceLanguage: sourceLanguage,
        targetLanguage: selectedLanguages,
        inputUri: fileUploadedData.gsUri,
        file_name: fileUploadedData.originalName,
        file_url: fileUploadedData.filePathUrl,
        file_type: fileType,
        num_of_pages: numPages,
        glossary_id: glossaryList.length > 0 ? selectedGlossary : null
      }

      dispatch(htmlFileTranslateAction(data, onBatchTranslateSuccess, onBatchTranslateError));

    } else {
      if (!isBatchTranslate) {
        const data = {
          sourceLanguage: sourceLanguage,
          targetLanguage: targetLanguage,
          inputUri: fileUploadedData.gsUri,
          file_name: fileUploadedData.originalName,
          file_url: fileUploadedData.filePathUrl,
          file_type: fileType,
          num_of_pages: numPages,
          glossary_id: glossaryList.length > 0 ? selectedGlossary : null
        }
        if (numPages > 20) {
          dispatch(translateBatchDocMoreThan20Action(data, onBatchTranslateSuccess, onBatchTranslateError));
        } else {
          dispatch(translateDocAction(data, onTranslateSuccess, onTranslateError));
        }
      } else {
        const data = {
          sourceLanguage: sourceLanguage,
          targetLanguage: selectedLanguages,
          inputUri: fileUploadedData.gsUri,
          file_name: fileUploadedData.originalName,
          file_url: fileUploadedData.filePathUrl,
          file_type: fileType,
          num_of_pages: numPages,
          glossary_id: glossaryList.length > 0 ? selectedGlossary : null
        }
        if (numPages > 20) {
          dispatch(translateBatchDocMoreThan20Action(data, onBatchTranslateSuccess, onBatchTranslateError));
        } else {
          dispatch(translateBatchDocAction(data, onBatchTranslateSuccess, onBatchTranslateError));
        }
      }
    }
    setLoading(true)
  }

  const createDataUrl = (buffer, fileType) => {
    const uint8Array = new Uint8Array(buffer);
    const blob = new Blob([uint8Array], { type: `application/${fileType}` });
    if (fileType === "pdf") {
      return URL.createObjectURL(blob);
    } else {
      console.log('buffer is ', buffer);
      return buffer
    }
  };

  const onTranslateSuccess = (data) => {
    if (fileType === "pdf") {
      setDataUrl(createDataUrl(data.data.data.data, fileType));
    } else {
      setDataUrl(data.data.data);
    }
    setLoading(false);
    setFileTranslated(true)
  }

  const onTranslateError = (data) => {
    setLoading(false);
    errorToast(data.data.message);
  }

  const onBatchTranslateSuccess = (data) => {
    setBatchTranslatedData(data.data.data);
    setLoading(false);
    setFileTranslated(true);
    const dispatchingData = {
      fileUri: selectedGlossary ? data.data.data[0].glossaryFileUrl : data.data.data[0].translatedDocumentUrl
    }
    setSelectedButton(data.data.data[0].translatedLanguage)
    dispatch(viewTranslateBatchDocAction(dispatchingData, onBatchViewDocSuccess, onBatchViewDocError));
  }
  const onBatchTranslateError = (data) => {
    setLoading(false);
    if (data.data.errors === "TRANSLATE_TIME") {
      setTranslateText(data.data.message);
      setShowPopup(true)
    } else {
      errorToast(data.data.message);
    }
  }

  const onCLickTranslatedLanguages = (data, translatedLanguage) => {
    const dispatchingData = {
      fileUri: data
    }
    dispatch(viewTranslateBatchDocAction(dispatchingData, onBatchViewDocSuccess, onBatchViewDocError));
    setSelectedButton(translatedLanguage);
  }

  const onBatchViewDocSuccess = (data) => {
    setDataUrl(createDataUrl(data.data.data.data, fileType));
    if (fileType === "pdf") {
      setDataUrl(createDataUrl(data.data.data.data, fileType));
    } else {
      setDataUrl(data.data.data);
    }
    setLoading(false);
    setFileTranslated(true)
  }

  const onBatchViewDocError = (data) => {
    setLoading(false);
    errorToast(data.data.message);
  }

  const handlePrevious = () => {
    if (startIndex > 0) {
      if (startIndex - visibleButtons > 0) {
        setStartIndex(startIndex - visibleButtons);
      } else {
        setStartIndex(0);
      }
    }
  };

  const handleNext = () => {
    if (startIndex + visibleButtons < totalButtons) {
      setStartIndex(startIndex + visibleButtons);
    }
  };

  const onClickDownload = async (data, translatedLanguage) => {
    const translatedName = availableLanguages.find(
      (item) => item.value === translatedLanguage
    );

    const response = await fetch(data);
    const blob = await response.blob();

    const originalName = fileUploadedData?.originalName || "download";
    const lastDotIndex = originalName.lastIndexOf(".");

    const fileName =
      lastDotIndex !== -1
        ? originalName.substring(0, lastDotIndex)
        : originalName;

    const extension =
      lastDotIndex !== -1
        ? originalName.substring(lastDotIndex + 1)
        : "";

    saveAs(
      blob,
      `${fileName}_${translatedName?.label}${extension ? `.${extension}` : ""}`
    );
  };

  const uploadFileToGoogleDrive = async (fileUrl, translatedLanguage) => {
    try {
      // Fetch the file from the URL
      setShowLoader(true)
      const response = await fetch(fileUrl);
      const fileBlob = await response.blob();
      const translatedName = availableLanguages.find((itemdata) => itemdata.value === translatedLanguage)

      const originalName = fileUploadedData?.originalName || "download";
      const lastDotIndex = originalName.lastIndexOf(".");

      const fileName =
        lastDotIndex !== -1
          ? originalName.substring(0, lastDotIndex)
          : originalName;

      const extension =
        lastDotIndex !== -1
          ? originalName.substring(lastDotIndex + 1)
          : "";

      const metadata = {
        name: `${fileName}_${translatedName.label}${extension ? `.${extension}` : ""}`,
        mimeType: fileBlob.type,
      };

      // Prepare the form data
      const form = new FormData();
      form.append(
        "metadata",
        new Blob([JSON.stringify(metadata)], { type: "application/json" })
      );
      form.append("file", fileBlob);

      // Send the file to Google Drive
      const uploadResponse = await fetch(
        "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id",
        {
          method: "POST",
          headers: new Headers({
            Authorization: `Bearer ${accessToken}`,
          }),
          body: form,
        }
      );
      const result = await uploadResponse.json();

      if (uploadResponse.ok) {
        console.log("File uploaded successfully. File ID:", result.id);
        setShowLoader(false)
        successToast("File Exported Successfully");
      } else {
        console.error("Error uploading file:", result.error);
        setShowLoader(false)
        errorToast('Unable to export file try again later');
      }
    } catch (error) {
      setShowLoader(false)
      console.error("An error occurred during the file upload:", error);
      errorToast('Unable to export file try again later');
    }
  };


  console.log("fileType", fileType);
  return (
    <TranslationLayout>
      <div className='uploading_div_translation mb-1 d-md-flex gap-3 mx-3' style={{ backgroundColor: '#f5f5f5', height: '90vh', width: '95%' }}>
        <div className='uploading px-3 pt-4'>
          <div className='d-flex mx-4 justify-content-between align-content-center' style={{ position: 'relative' }}>
            <Button variant={'primary'} className={`text-nowrap`}>
              <div className='fs_12'>
                {availableLanguages.map((itemdata) => {
                  if (itemdata.value === sourceLanguage) {
                    return itemdata.label;
                  }
                  return null;
                })}
              </div>
            </Button>
          </div>
          {fileType === "pdf" || fileType === "html" ? <iframe title="File Preview" src={fileUploadedData.signedUrl} style={{ width: '80%', height: '95%', border: 'none' }} className='pt-3 pb-3' /> :
            <DocFileViewer fileUrl={fileUploadedData.signedUrl} />
          }
        </div>
        {loading ?
          <div className='uploading'>
            <div className='d-flex flex-wrap'>
              {selectedLanguages.map((selectedLang, index) => {
                const languageData = availableLanguages.find(lang => lang.value === selectedLang);
                if (languageData && index < 3) {
                  return (
                    <div className='d-flex mb-2 mt-4 ml-6 mx-1 fs_12' key={languageData.value} style={{ marginRight: '50px' }}>
                      <Button
                        disabled={true}
                        variant='primary'
                        className='d-flex text-nowrap'
                        style={{ minWidth: '80px' }}
                      >
                        <div className='fs_12 d-flex gap-1'>
                          <Spinner size="sm" />
                          {languageData.label}
                        </div>
                      </Button>
                    </div>
                  );
                }
                return null;
              })}
              <div className='d-flex mb-2 mt-4 ml-6 mx-1 fs_12' style={{ marginRight: '50px' }}>
                {selectedLanguages.length > 3 &&
                  <Button
                    disabled={true}
                    variant='primary'
                    className='d-flex text-nowrap'
                    style={{ minWidth: '80px' }}
                  >
                    <div className='fs_12 d-flex gap-1'>
                      <Spinner size="sm" />
                      +{selectedLanguages.length - 3} more
                    </div>
                  </Button>
                }
              </div>
            </div>
            <Loading text={"Translating Doc"} />
          </div> :
          fileTranslated ?
            <div className={`uploading px-3 ${batchTranslatedData.length > 0 ? "pt-3" : "pt-3"}`}>
              {batchTranslatedData.length > 0 ?
                <div className='d-flex px-1' style={{ position: 'relative' }}>
                  {startIndex > 0 && (
                    <Button onClick={handlePrevious} className='mx-1 d-flex' style={{ backgroundColor: "#1A73E8", alignItems: 'center', backgroundColor: 'white', color: 'blue', height: '30px', }}>&lt;</Button>
                  )}
                  <div className='d-flex'>
                    {batchTranslatedData.slice(startIndex, startIndex + visibleButtons).map((item, index) => (
                      <div className='d-flex mx-1' key={index} style={{ minWidth: '80px' }}>
                        <Button variant={`${selectedButton === item.translatedLanguage ? 'success' : 'primary'}`} className={`text-nowrap`} onClick={() => onCLickTranslatedLanguages(!item.is_glossary ? item.translatedDocumentUrl : item.glossaryFileUrl, item.translatedLanguage)}>
                          <div className='fs_12'>
                            {availableLanguages.map((itemdata) => {
                              if (itemdata.value === item.translatedLanguage) {
                                return itemdata.label;
                              }
                              return null;
                            })}
                          </div>
                        </Button>
                      </div>
                    ))}
                  </div>
                  {startIndex + visibleButtons < totalButtons && (
                    <Button onClick={handleNext} className='mx-1 d-flex' style={{ backgroundColor: 'white', color: 'blue', height: '30px', alignItems: 'center' }}>+{totalButtons - 4}&gt;</Button>
                  )}
                  <div className='d-flex gap-2 w-100 justify-content-end align-items-center'>
                    <div className="cursor_pointer mt-1">
                      {!accessToken ?
                        <div>
                          <GoogleDrivePicker setAccessTokens={setAccessToken} type={"export"} />
                        </div>
                        :
                        <ImGoogleDrive onClick={() => uploadFileToGoogleDrive(dataUrl, selectedButton)} />
                      }
                    </div>
                    <img src={downloadIcon} alt="download-icon" style={{ height: '16px' }} className="cursor_pointer px-2 mt-1" onClick={() => onClickDownload(dataUrl, selectedButton)} />
                  </div>
                </div>
                :
                <div className='d-flex mx-4 justify-content-between align-content-center' style={{ position: 'relative' }}>
                  <Button variant={'success'} className={`text-nowrap`}>
                    <div className='fs_12'>
                      {availableLanguages.map((itemdata) => {
                        if (itemdata.value === targetLanguage) {
                          return itemdata.label;
                        }
                        return null;
                      })}
                    </div>
                  </Button>
                  <div className='d-flex gap-2 w-100 justify-content-end align-items-center'>
                    <div className="cursor_pointer mt-1">
                      {!accessToken ?
                        <div>
                          <GoogleDrivePicker setAccessTokens={setAccessToken} type={"export"} />
                        </div>
                        :
                        <ImGoogleDrive onClick={() => uploadFileToGoogleDrive(dataUrl, targetLanguage)} />
                      }
                    </div>
                    <img src={downloadIcon} alt="download-icon" style={{ height: '16px' }} className="cursor_pointer px-2 mt-1" onClick={() => onClickDownload(dataUrl, targetLanguage)} />
                  </div>
                </div>
              }
              {fileType === "pdf" || fileType === "html" ?
                <iframe title="File Preview" src={dataUrl} style={{ width: '80%', height: '95%', border: 'none' }} className='pt-3 pb-3' />
                :
                <TranslatedDocFileViewer fileUrl={dataUrl} />
              }
            </div>
            :
            <div className='translation-div'>
              <div className='d-flex gap-4 pt-4 px-2 justify-content-evenly'>
                <select
                  value={sourceLanguage}
                  onChange={(e) => { setSourceLanguage(e.target.value); setTargetLanguage(""); setSelectedLanguages([]) }}
                  className='source_lanuage btn btn-primary btn-outline-light text-start'
                  style={{ width: '15%' }}
                >
                  {availableLanguages.map((language) => (
                    <option key={language.value} value={language.value}>
                      {language.label}
                    </option>
                  ))}

                </select>
                <button onClick={toggleDropdown} className='dropbtn btn btn-primary'>
                  Select Languages
                </button>
                <button onClick={GlossariesDropdown} className=' btn btn-primary'>
                  {selectedGlossary ? selectedGlossary : 'Select Glossaries'}
                </button>
                <button type="submit" onClick={handleTranslateButton} className='btn btn-primary'>Translate</button>
              </div>
              <div>
                {showDropdown && (
                  <div className='overflow-auto mx-4 mt-1' style={{ height: '38rem', width: '40rem' }}>
                    <div className='dropdown-content d-flex flex-column'>
                      <input
                        type="text"
                        id="myInput"
                        value={filter}
                        onChange={handleFilterChange}
                        placeholder="Search for language.."
                        title="Type in a language name"
                        style={{ height: '35px' }}
                        className='input-field'
                      />

                      <div className='row mx-2'>
                        {filteredLanguages.map((lang) => (
                          <div className="col-md-4 mb-3" key={lang.value}>
                            <div className="d-flex gap-2 align-items-center w-100">
                              <input
                                type="checkbox"
                                name="language"
                                value={lang.value}
                                onChange={handleCheckboxChange}
                                checked={selectedLanguages.includes(lang.value)}
                                disabled={sourceLanguage === lang.value}
                                className='cursor_pointer'
                              />
                              <label
                                className='text-nowrap text-start'
                                title={lang.label}
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  display: 'block',
                                  width: '100%'
                                }}
                              >
                                {lang.label}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {glossariesDropdown && (
                  <div className='card glossary-list mt-3 h-100'>
                    {glossaryList.length > 0 ? glossaryList.map((item, index) => (
                      <label
                        key={item?.glossary?.name}
                        className='hover-effect cursor_pointer mx-3 my-1'
                        onClick={() => handleGlossaryLabelClick(item?.glossary?.name)}
                      >
                        {item?.glossary?.name}
                      </label>
                    )) : "No Glossaries Found For Selected Language Set"}
                  </div>
                )}
              </div>
            </div>
        }
      </div>
      <LoaderModal show={showLoader} handleClose={() => setShowLoader(!showLoader)} text="Exporting..." />
      <TOSModal show={showPrompt} handleClose={() => setShowPrompt(false)} />
      <Popup show={showPopup} handleClose={() => setShowPopup(false)} text={translateText} />
    </TranslationLayout>
  )
}